
export const filterData = (searchText, allRestaurants) => {
  if (searchText.length === 0) return allRestaurants;
  return allRestaurants.filter((restaurant) =>
    restaurant.name.toLowerCase().includes(searchText.toLowerCase())
  );
};